export default __webpack_public_path__ + "dca7596b404695f9bc014fc6172066c6.svg";